import { useNavigate } from "react-router-dom";

import { T } from "@repo/transifex";
import { Button } from "~/components/Button";
import { cn } from "~/lib/utils";

import { useOrdersCreateActions } from "../__app.collect.orders.create/orders-create-context";

type HeaderButtonsProps = {
  onSave?: () => void;
  isSaveDisabled?: boolean;
  isBalanceInsufficient?: boolean;
};

export const HeaderButtons = ({
  onSave,
  isSaveDisabled,
  isBalanceInsufficient
}: HeaderButtonsProps) => {
  const navigate = useNavigate();

  const { reset } = useOrdersCreateActions();

  return (
    <div className="flex flex-row gap-2">
      <Button
        className="rounded-full"
        variant="secondary"
        onClick={() => {
          reset();
          navigate(-1);
        }}
      >
        <T _str="Cancel" />
      </Button>

      <Button
        onClick={onSave}
        disabled={isSaveDisabled}
        className={cn("rounded-full", {
          "bg-interface-negative-4 text-interface-negative-2":
            isBalanceInsufficient,
          "bg-interface-neutral-6 text-interface-accent-1":
            !isBalanceInsufficient
        })}
      >
        {isBalanceInsufficient ? (
          <T _str="Insufficient balance" />
        ) : (
          <T _str="Save" />
        )}
      </Button>
    </div>
  );
};
